module.exports = "<!-- Copyright The Linux Foundation and each contributor to LFX. -->\n<!-- SPDX-License-Identifier: MIT -->\n<button (click)=\"navigateBack()\" class=\"btn btn-icon btn-3 btn-link-default\" type=\"button\">\n\t  <span class=\"btn-inner--icon\"><i class=\"ni ni-bold-left\"></i></span>\n    <span class=\"btn-inner--text\" i18n>Back</span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/back-button/back-button.component.html
// module id = ./src/app/shared/back-button/back-button.component.html
// module chunks = main